export const fontSizeBase = '1rem'
export const fontSizeBig = '1.25rem'
export const fontSizeSmall = '.875rem'
export const fontSizeTiny = '.75rem'
export const fontSizeMin = '.625rem'

export const weightThin = 300
export const weightNormal = 400
export const weightBold = 700
